import { inject, RESPONSE_INIT } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { DskHomeUserStore } from '../../store/dskhome-user';
import { applyServer302Redirect } from '../../utils/server-redirects';

export const dskhomeVerifiedPhoneNumberGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const dskHomeUserStore = inject(DskHomeUserStore);
  const responseInit = inject(RESPONSE_INIT);

  if (!dskHomeUserStore.phoneNumberVerified()) {
    const verificationApplicationRoute = router.parseUrl('/user-verification');
    const serializedUrl = router.serializeUrl(verificationApplicationRoute);

    applyServer302Redirect(responseInit, serializedUrl);

    return new RedirectCommand(verificationApplicationRoute);
  }

  return true;
};
